<!-- SITE -->
<template>
    <div>
        <!-- // * CONTENT TITLE (GENERIC) -->
        <v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 pl-4 pr-2 d-flex align-center white">
            <app-text category="content-title">
                <div class="d-flex align-center">
                    <span v-if="form[collectionItem + 'Name'] === ''" class="pl-2">{{ $t(`${langPath}.new`) }}</span>
                    <span v-else class="pl-2 d-inline-block text-truncate">{{ form[collectionItem + 'Name'] }} </span>
                </div>
            </app-text>
            <v-spacer></v-spacer>
            <appbutton label="Live Roll Call" v-if="formMode !== 'New' && form.delete == undefined" icon="icons8-fire" type="purple"  class="mr-1" @click.native="MIX_go('/liveRollCall/' + form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
            
        </v-row>
        <v-divider class="grey lighten-1"></v-divider>
        <!-- // * CONTENT (CUSTOM) -->
        <v-container fluid class="pa-0"  >
            <v-row no-gutters class="">
                <v-col cols="12" xs="6" lg="12" class="">
                    <v-row class="ma-0" no-gutters>
                        <!-- // * TABS MENU (CUSTOM) -->
                        <v-tabs class="border-bottom-grey" v-model="tabs" height="53" show-arrows>
                            <v-tabs-slider color="red" background-color="black"></v-tabs-slider>
                            <v-tab href="#overview" class="white"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption text-uppercase">{{$t(`${langPath}.overview.tabName`)}}</span></v-tab>
                            <v-tab href="#locations" v-if="formMode !== 'New'" class="white"><v-icon class="mr-2">icons8-address</v-icon> <span class="caption">{{$t(`${langPath}.locations.tabName`)}} ({{ locationsTableData.length }})</span></v-tab>
                            <!-- <v-tab href="#projects" class="white"><v-icon class="mr-2">icons8-project</v-icon> <span class="caption">{{ $t(`${langPath}.projects.tabName`) }} ({{ commentsTableData.length }})</span></v-tab> -->
                            <v-tab href="#concerns"  v-if="formMode !== 'New'" class="white"><v-icon class="mr-2">icons8-comments</v-icon> <span class="caption">{{$t(`${langPath}.concerns.tabName`)}} ({{ calculateArrayLength(computedConcernsTableData) }})</span></v-tab>
                            <v-tab href="#notices"   v-if="formMode !== 'New'" class="white"><v-icon class="mr-2">icons8-note</v-icon> <span class="caption">{{$t(`${langPath}.notices.tabName`)}} ({{ noticesTableData.length}})</span></v-tab>
                            <v-tab href="#history" class="white"><v-icon class="mr-2">icons8-chat-messages</v-icon> <span class="caption">{{ $t(`${langPath}.history.tabName`) }} ({{ calculateArrayLength(commentsTableData) }})</span></v-tab>
                            <!-- <v-tab href="#guide" class="white" v-if="guide.content !== null"><v-icon class="mr-2">icons8-help</v-icon> <span class="caption">{{ $t(`${langPath}.guide.tabName`) }}</span></v-tab> -->

                        </v-tabs>
                        <!-- // * TABS ITEMS (CUSTOM) -->
                        <v-tabs-items v-model="tabs" class="appbackground">
                            <!-- // * GUIDE -->
                            <v-tab-item value="guide" class="pa-0">
                                <v-row class="mt-4 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.guide.title`) }}</app-text>
                                                <v-divider class="my-4"/>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-4 ma-0 px-3" no-gutters>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <span v-html="guide.content"></span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- // * DETAILS -->
                            <v-tab-item value="overview" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION (GENERIC) -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.overview.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.overview.text`) }}</app-text>
                                                <v-divider class="my-4"/>
                                            </v-col>
                                            <v-col class="pa-0 d-flex px-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton :label="$t(`buttons.destroy`)" v-if="formMode !== 'New' && form.delete !== undefined" icon="icons8-fire" type="purple"  class="mr-1" @click.native="destroyItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.undelete`)" v-if="formMode !== 'New' && form.delete !== undefined" icon="icons8-process" type="purple"  class="mr-1" @click.native="undeleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.delete`)" v-if="formMode !== 'New' && form.delete === undefined" icon="icons8-trash" type="secondary"  class="mr-1" @click.native="deleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.edit`)" v-if="formMode !== 'New'" icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="editItem()" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly" />
                                                <v-spacer />
                                                <appbutton :label="$t(`buttons.cancel`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-cancel" type="grey darken-2"  class="mr-1" @click.native="cancelItem()" showlabel="xlOnly" />
                                                <appbutton :label="$t(`buttons.save`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-save" type="info"  class="mr-0" @click.native="validateForm()" showlabel="xlOnly" />
                                            </v-col>
                                        </v-row>
                                        <!-- // * FORM -->
                                        <v-form ref="form"  >
                                        <v-row class="mt-2" no-gutters>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" :label="$t(`fields.name`)" v-model="form.siteName" filled hide-details="auto" required :rules="rules.siteName" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" :label="$t(`fields.telephone`)" v-model="form.siteTelephone" filled hide-details="auto" required :rules="rules.siteTelephone" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" :label="$t(`fields.addressLine1`)" v-model="form.siteAddressLine1" filled hide-details="auto" required :rules="rules.siteAddressLine1" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" :label="$t(`fields.addressLine2`)" v-model="form.siteAddressLine2" filled hide-details :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" :label="$t(`fields.addressLine3`)" v-model="form.siteAddressLine3" filled hide-details :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" :label="$t(`fields.town`)" v-model="form.siteTown" filled hide-details="auto" required :rules="rules.siteTown" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" :label="$t(`fields.county`)" v-model="form.siteCounty" filled hide-details :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" :label="$t(`fields.postcode`)" v-model="form.sitePostcode" filled hide-details="auto" required :rules="rules.sitePostcode" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" color="black"  :label="$t(`fields.type`)" v-model="form.siteType" :items="siteTypes" item-text="text" item-value="value" dense filled hide-details="auto" required :rules="rules.siteType" :background-color="formBackground" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }">
                                                    <template v-slot:item="data">
                                                        {{ data.item.text }}
                                                    </template>
                                                    <template v-slot:selection="data">
                                                        {{ data.item.text }}
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <!-- NOTES -->
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <h5 class="grey--text text--darken-1">NOTES</h5>
                                                <v-divider class="mb-4 mt-2" />
                                                <v-textarea color="black"  :label="$t(`fields.notes`)" v-model="form.notes" filled hide-details :background-color="formBackground" dense auto-grow rows="4" clearable :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-textarea>
                                            </v-col>
                                            <!-- INFO -->
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="formMode !== 'New'">
                                                <v-divider />

                                                <div class="caption grey--text text--darken-1 pt-2">
                                                    <strong>{{$t('fields.created')}}: </strong> {{ form.createdUserData.userName }} - {{ form.createdUserData.organisationName }} - {{ MIX_formatDateTime(form.createdDateTime, 'x', 'DD-MMM-YYYY') }} |
                                                    <strong>{{$t('fields.modified')}}:</strong> {{ form.modifiedUserData.userName }} - {{ form.modifiedUserData.organisationName }} - {{ MIX_formatDateTime(form.modifiedDateTime, 'x', 'DD-MMM-YYYY') }}
                                                </div>
                                            </v-col>
                                        </v-row>
                                        </v-form>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- // * LOCATIONS -->
                            <v-tab-item value="locations" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.locations.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.locations.text`) }}</app-text>
                                                <v-divider class="my-4"/>
                                            </v-col>

                                            <v-col class="d-flex pa-0 ma-0 pl-1 d-flex align-center" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton :label="$t('buttons.add')"  icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="MIX_location(true, 'sites', form.id, form.locations, {id: form.id, siteName: form.siteName, siteType: form.siteType, sitePostocode: form.sitePostcode})" />
                                                <v-spacer />
                                                <div class="font-weight-bold grey--text">DELETED</div>
                                                <v-switch @change="getLocations(GET_openItem)" v-model="showDeletedLocations" class="ml-2 mr-0 secondary--text" inset></v-switch>
                                            </v-col>

                                            <!-- <v-col cols="12">
                                                <pre>{{ usersTableData }}></pre>
                                            </v-col> -->

                                            <v-col cols="12" class="my-4 px-2">
                                                <v-data-table
                                                    :headers="locationsHeaders"
                                                    :items="locationsTableData"
                                                    :items-per-page="10"
                                                    class="elevation-1">
                                                        <template v-slot:[`item.contractors`]="{ item }">
                                                            <span>{{noOfUsersAtLocation(item.id, 'CONTRACTOR')}}</span>
                                                        </template>
                                                        <template v-slot:[`item.visitors`]="{ item }">
                                                            <span>{{noOfUsersAtLocation(item.id, 'VISITOR')}}</span>
                                                        </template>
                                                        <template v-slot:[`item.staff`]="{ item }">
                                                            <span>{{noOfUsersAtLocation(item.id, 'STAFF')}}</span>
                                                        </template>
                                                        <template v-slot:[`item.totalCount`]="{ item }">
                                                            <span>{{noOfUsersAtLocation(item.id, '')}}</span>
                                                        </template>
                                                        <template v-slot:[`item.actions`]="{ item }">
                                                            <v-icon @click="openQrCode(item.id, item)">icons8-qr-code</v-icon>
                                                            <!-- <v-icon>icons8-bar-chart</v-icon> -->
                                                            <v-icon @click="MIX_deleteCollectionArray(item.id, item, 'locations')">icons8-trash</v-icon>
                                                        </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- // * PROJECTS -->
                            <!-- <v-tab-item value="projects" class="pa-0">
                                <v-row class="mt-4 ma-0" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="ma-0 pl-3 pr-2">
                                            <v-col cols="12" class="pa-1">
                                                <app-text category="tab-title">{{ $t(`${langPath}.projects.title`) }}</app-text>
                                                <app-text category="tab-text">{{ $t(`${langPath}.projects.text`) }}</app-text>
                                                <v-divider class="mt-4"/>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item> -->

                            <!-- // * CONCERNS -->
                            <v-tab-item value="concerns" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.concerns.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.concerns.text.default`) }}</app-text>
                                                <v-divider class="my-4"/>
                                            </v-col>

                                            <v-col class="d-flex pa-0 ma-0 pl-1 d-flex align-center" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton :label="$t('buttons.add')"  icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="MIX_popupConcern('', 'New')" />
                                                <v-spacer />
                                                <div class="font-weight-bold grey--text">DELETED</div>
                                                <v-switch @change="getConcerns(GET_openItem)" v-model="showDeletedConcerns" class="ml-4 secondary--text" inset></v-switch>
                                            </v-col>

                                            <v-col cols="12" class="my-4 px-2">
                                                <!-- ConcernTypes: {{ concernTypes }}<br />
                                                ConcernSeveriries: {{ concernSeverities }} -->
                                                <v-data-table
                                                    :headers="computedConcernsHeaders"
                                                    :items="computedConcernsTableData"
                                                    :items-per-page="10"
                                                    item-key="id"
                                                    class="elevation-0"

                                                    >
                                                        <!-- // HEADERS (GENERIC) -->
                                                        <!-- <template v-slot:header="{ props }">
                                                            <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">
                                                                {{ $t(`fields.${head.text}`) }}
                                                            </th>
                                                        </template> -->
                                                        <!-- STATUS (CUSTOM) -->
                                                        <template v-slot:[`item.concernStatus`]="{ item }">
                                                            <v-icon v-if="item.concernStatus === 'RESOLVED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                                                            <v-icon v-if="item.concernStatus === 'ONHOLD'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-private"></v-icon>
                                                            <v-icon v-if="item.concernStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                                                        </template>
                                                        <!-- NAME (CUSTOM) -->
                                                        <template v-slot:[`item.concernName`]="{ item }">
                                                          <span v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" class="purple--text"><v-icon class="purple--text">icons8-trash</v-icon> {{ item.concernName}}</span>
                                                          <span v-else>{{ item.concernName }}</span>
                                                        </template>
                                                        <!-- // CONCERN TYPE (CUSTOM) -->
                                                        <template v-slot:[`item.concernType`]="{ item }">
                                                            {{ lookupField('concernTypes', 'text', item.concernType)  }}
                                                        </template>
                                                        <!-- // CONCERN SEVERITIES (CUSTOM) -->
                                                        <template v-slot:[`item.concernSeverity`]="{ item }">
                                                            <span v-if="item.concernSeverity === 'URGENT'" class="error--text">{{ lookupField('concernSeverities', 'text', item.concernSeverity)  }}</span>
                                                            <span v-if="item.concernSeverity === 'HIGH'" class="error--text">{{ lookupField('concernSeverities', 'text', item.concernSeverity)  }}</span>
                                                            <span v-if="item.concernSeverity === 'MEDIUM'" class="warning--text">{{ lookupField('concernSeverities', 'text', item.concernSeverity)  }}</span>
                                                            <span v-if="item.concernSeverity === 'LOW'" class="success--text">{{ lookupField('concernSeverities', 'text', item.concernSeverity)  }}</span>
                                                        </template>
                                                        <!-- // CREATED USER DATA (GENERIC) -->
                                                        <template v-slot:[`item.createdUserData`]="{ item }">
                                                            <div v-if="item.createdUserData !== '' && item.createdUserData !== undefined && item.createdUserData !== null" @click="MIX_popupUser(item.createdUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>
                                                                {{ item.createdUserData.userName }}
                                                            </div>
                                                        </template>
                                                        <!-- // MODIFIED USER DATA (GENERIC) -->
                                                        <template v-slot:[`item.modifiedUserData`]="{ item }">
                                                            <div v-if="item.modifiedUserData !== '' && item.modifiedUserData !== undefined && item.modifiedUserData !== null" @click="MIX_popupUser(item.modifiedUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>
                                                                {{ item.modifiedUserData.userName }}
                                                            </div>
                                                        </template>
                                                        <!-- // DELETE USER DATA (GENERIC) -->
                                                        <template v-slot:[`item.deleteUserData`]="{ item }">
                                                            <div v-if="item.deleteUserData !== '' && item.deleteUserData !== undefined && item.deleteUserData !== null" @click="MIX_popupUser(item.deleteUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>
                                                                {{ item.deleteUserData.userName }}
                                                            </div>
                                                        </template>
                                                        <template v-slot:[`item.actions`]="{ item }">
                                                            <v-icon v-if="item.delete === null || item.delete === '' || item.delete === undefined" @click="MIX_popupConcern(item.id, '')">icons8-edit-property</v-icon>
                                                            <!-- <v-icon v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" @click="MIX_undelete('concerns', 'Concern', item.id)">icons8-process</v-icon>
                                                            <v-icon v-if="item.delete === null || item.delete === '' || item.delete === undefined" @click="deleteConcern(item)">icons8-trash</v-icon> -->
                                                        </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- // * NOTICES -->
                            <v-tab-item value="notices" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.notices.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.notices.text`) }}</app-text>
                                                <v-divider class="my-4"/>
                                            </v-col>

                                            <v-col class="d-flex pa-0 ma-0 pl-1 d-flex align-center" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton :label="$t('buttons.add')"  icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="MIX_popupNotice('', 'New', true, false)" />
                                                <v-spacer />
                                                <div class="font-weight-bold grey--text">DELETED</div>
                                                <v-switch @change="getNotices(GET_openItem)" v-model="showDeletedNotices" class="ml-4 secondary--text" inset></v-switch>
                                            </v-col>

                                            <v-col cols="12" class="my-4 px-2">
                                                <v-data-table
                                                    :headers="noticesHeaders"
                                                    :items="noticesTableData"
                                                    :items-per-page="10"
                                                    class="elevation-1">
                                                        <template v-slot:[`item.noticeName`]="{ item }">
                                                            <span v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" class="error--text"><v-icon class="error--text">icons8-trash</v-icon> {{ item.noticeName}}</span>
                                                            <span v-else>{{ item.noticeName }}</span>
                                                        </template>
                                                        <template v-slot:[`item.createdDateTime`]="{ item }">
                                                            <span>{{MIX_formatDateTime(item.createdDateTime, 'x', 'DD-MMM-YY HH:mm')}}</span>
                                                        </template>
                                                        <template v-slot:[`item.noticeStatus`]="{ item }">
                                                            <v-icon v-if="item.noticeStatus === 'LIVE'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                                                            <v-icon v-if="item.noticeStatus === 'DRAFT'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                                                        </template>
                                                        <template v-slot:[`item.actions`]="{ item }">
                                                            <v-icon v-if="item.delete === null || item.delete === '' || item.delete === undefined" @click="MIX_popupNotice(item.id, 'Edit', true, false)">icons8-edit-property</v-icon>
                                                            <!-- <v-icon v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" @click="MIX_undelete('notices', 'Notice', item.id)">icons8-process</v-icon>
                                                            <v-icon v-if="item.delete === null || item.delete === '' || item.delete === undefined" @click="deleteNotice(item)">icons8-trash</v-icon> -->
                                                        </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- HISTORY / COMMENTS -->
                            <v-tab-item value="history" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- HISTORY DESCRIPTION (GENERIC) -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.history.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.history.text`) }}</app-text>
                                                <v-divider class="my-4"/>
                                            </v-col>
                                            <!-- HISTORY / COMMENTS ACTION BAR (CUSTOM) -->
                                            <v-col class="d-flex pa-0 ma-0 pl-1 d-flex align-center" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton :label="$t('buttons.add')"  icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="MIX_comment({ show: true, action: 'New', data: { comment: '', private: true, docLink: { collection: 'concerns', documentId: form.id } } })" />
                                                <v-spacer />
                                                <div class="font-weight-bold grey--text">ID</div>
                                                <v-switch v-model="showIDComments" class="ml-4 secondary--text" inset></v-switch>
                                                <div class="font-weight-bold purple--text"><v-icon class="ml-4 purple--text text-h4">icons8-trash</v-icon></div>
                                                <v-switch @change="getComments(GET_openItem)" v-model="showDeletedComments" class="ml-4 secondary--text" inset></v-switch>
                                            </v-col>
                                            <!-- HISTORY / COMMENTS DATA TABLE -->
                                            <v-col cols="12" class="my-4 px-2">
                                                <v-data-table
                                                    id="commentstable"
                                                    :headers="computedCommentsHeaders"
                                                    :items="computedCommentsTableData"
                                                    :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                                                    item-key="id"
                                                    class="elevation-0"
                                                    dense
                                                    hide-default-header
                                                    >
                                                        <!-- // STATUS -->
                                                        <template v-slot:[`item.concernStatus`]="{ item }">
                                                            <v-icon v-if="item.concernStatus === 'RESOLVED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                                                            <v-icon v-if="item.concernStatus === 'ONHOLD'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-private"></v-icon>
                                                            <v-icon v-if="item.concernStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                                                        </template>
                                                        <!-- // HEADERS (GENERIC) -->
                                                        <template v-slot:header="{ props }">
                                                            <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">
                                                                {{ $t(`fields.${head.text}`) }}
                                                            </th>
                                                        </template>
                                                        <!-- // COMMENT (GENERIC) -->
                                                        <template v-slot:[`item.comment`]="{ item }">
                                                            <span v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" class="purple--text"><v-icon class="purple--text">icons8-trash</v-icon> {{ item.comment}}</span>
                                                            <span v-else>{{ item.comment }}</span>
                                                        </template>
                                                        <!-- // PRIVATE (GENERIC) -->
                                                        <template v-slot:[`item.private`]="{ item }">
                                                            <v-icon v-if="item.private === true">icons8-lock</v-icon>
                                                            <v-icon v-if="item.private === false"></v-icon>
                                                        </template>
                                                        <!-- // DOC LINK -->
                                                        <template v-slot:[`item.docLink`]="{ item }">
                                                            {{ item.docLink.documentId }}
                                                        </template>
                                                        <!-- // CREATED USER DATA -->
                                                        <template v-slot:[`item.createdUserData`]="{ item }">
                                                            <div v-if="item.createdUserData !== '' && item.createdUserData !== undefined && item.createdUserData !== null" @click="MIX_popupUser(item.createdUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>
                                                                {{ item.createdUserData.userName }}<br />
                                                                <span class="caption">{{ item.createdDateTime }}</span>
                                                            </div>
                                                        </template>
                                                        <!-- // MODIFIED USER DATA -->
                                                        <template v-slot:[`item.modifiedUserData`]="{ item }">
                                                            <div v-if="item.modifiedUserData !== '' && item.modifiedUserData !== undefined && item.modifiedUserData !== null" @click="MIX_popupUser(item.modifiedUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>
                                                                {{ item.modifiedUserData.userName }}
                                                                <span class="caption">{{ item.modifiedDateTime }}</span>
                                                            </div>
                                                        </template>
                                                        <!-- // DELETE USER DATA -->
                                                        <template v-slot:[`item.deleteUserData`]="{ item }">
                                                            <div v-if="item.deleteUserData !== '' && item.deleteUserData !== undefined && item.deleteUserData !== null" @click="MIX_popupUser(item.deleteUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>
                                                                {{ item.deleteUserData.userName }}
                                                                <span class="caption">{{ item.delete }}</span>
                                                            </div>
                                                        </template>
                                                        <!-- ACTIONS -->
                                                        <template v-slot:[`item.actions`]="{ item }">
                                                            <div class="actionscolumn">
                                                                <v-icon v-if="item.delete === null || item.delete === '' || item.delete === undefined" @click="MIX_comment({ show: true, action: 'Edit', data: { id: item.id, comment: item.comment, private: item.private } })">icons8-edit-property</v-icon>
                                                                <v-icon v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" @click="MIX_undelete('comments', 'Comment', item.id)">icons8-process</v-icon>
                                                                <v-icon v-if="item.delete === null || item.delete === '' || item.delete === undefined" @click="deleteComment(item)">icons8-trash</v-icon>
                                                            </div>
                                                        </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'; // Map the Getters from the Vuex Store
    export default {
        // * DATA
        data: () => ({
            // * PAGE DETAILS
            collection: 'sites',
            collectionTitle: 'Sites',
            collectionItem: 'site',
            collectionItemTitle: 'Site',
            langPath: 'sites.site',
            tabs: 'overview',
            // * FORM RELATED
            formMode: '', // formMode determins if form is in View / Edit / New mode
            formReadOnly: true, // formReadOnly when True form cannot be edited
            form: {
                siteName: '',
                siteType: '',
                siteTelephone: '',
                siteAddressLine1: '',
                siteAddressLine2: '',
                siteAddressLine3: '',
                siteTown: '',
                siteCounty: '',
                sitePostcode: '',
                locations: [],
                createdUserData: {},
                createdDateTime: '',
                modifiedUserData: {},
                modifiedDateTime: '',
                notes: ''
            },
            rules: {},
            formMode: 'New', // Show Form in New Mode / Blank
            formReadOnly: false, // Make Form Editable
            formBackground: 'grey lighten-3',

            // LOOKUPS
            siteTypes: [], // Site Types
            concernTypes: [], // Concern Types
            concernSeverities: [], // Concern Severities
            // CONCERNS RELATED
            concernsTableData: [],
            showDeletedConcerns: false,
            // LOCATIONS RELATED
            locationsTableData: [],
            usersTableData: [], // stores users which match last site Id
            showDeletedLocations: false,

            // * COMMENTS RELATED
            commentsTableData: [], // populated from firestore on show comments
            commentsHeaders: [
                { text: 'private',  value: 'private', align: 'center', sortable: false, hidden: false, hide: false },
                { text: 'id', value: 'id', align: 'start',  sortable: false, hidden: true, hide: false },
                { text: 'comment', value: 'comment', align: 'start', sortable: false, hidden: false, hide: false, },
                { text: 'docLink', value: 'docLink', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'createdUserData', value: 'createdUserData', align: 'start', sortable: false, hidden: false, hide: true },
                { text: 'created', value: 'createdDateTime', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'modifiedUserData', value: 'modifiedUserData', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'modified', value: 'modifiedDateTime', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'delete',   value: 'delete',  align: 'start',  sortable: false, hidden: true, hide: false },
                { text: 'deleteUserData', value: 'deleteUserData', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'actions', value: 'actions', align: 'center', sortable: false, hidden: false, hide: false, width: '100px' },
            ],
            showDeletedComments: false, // Show Deleted Comments
            showIDComments: false,

            // NOTICES RELATED
            noticesTableData: [],
            showDeletedNotices: false,

            concernsHeaders: [
                { text: 'Status',  value: 'concernStatus', align: 'center', sortable: false, hidden: false, hide: false },
                { text: 'Deleted',  value: 'delete', align: 'center', sortable: false, hidden: true, hide: false },
                { text: 'Name',  value: 'concernName', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'Type', value: 'concernType', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'Severity', value: 'concernSeverity', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'CreatedUserData', value: 'createdUserData', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'Created', value: 'createdDateTime', align: 'left', sortable: false, hidden: false, hide: false, width: '110px' },
                { text: 'Actions', value: 'actions', align: 'center', sortable: false, hidden: false, hide: false, width: '100px' },
            ],

            guide: {
                content: ''
            }

        }),
        // * COMPUTED
        computed: {
            // MAP GETTERS
            ...mapGetters({
                GET_openItem: 'GET_openSite', // Get Open notice Data
                GET_panelLayout: 'GET_panelLayout', // Panel Layout used for Layout Structure
                GET_openSite: 'GET_openSite', // Get Open Project Data
                GET_lookupValues: 'GET_lookupValues',
                GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult', // Get Confirm Box Result
                GET_help: 'GET_help'
            }),
            // COMPUTED COMMENTS HEADERS (GENERIC)
            computedCommentsHeaders() {
                var t = this;
                var headers = t.commentsHeaders;
                var newHeaders = []
                for (var i = 0; i < headers.length; i++) {
                    var header = headers[i]
                    if (header.hidden) {
                        switch (true) {
                            // Add in Cases that need to be manually controlled
                            case (header.text === 'id'):
                                if (t.showIDComments) { newHeaders.push(header) } // remove if false
                                break;
                            case (header.text === 'deleteUserData'):
                                if (t.showDeletedComments) { newHeaders.push(header) } // remove if false
                                break;
                            default:
                                // do nothing

                        }
                    } else {
                        newHeaders.push(header)
                    }
                }
                return newHeaders
            },
            // COMPUTED COMMENTS TABLE DATA (GENERIC)
            computedCommentsTableData() {
                var t = this;
                var tableData = t.commentsTableData;
                var tableDataList = tableData.map(e => {
                    return {
                        private: e.private,
                        id: e.id,
                        comment: e.comment,
                        docLink: e.docLink,
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });
                return (tableDataList);
            },



            // COMPUTED CONCERNS TABLE DATA (GENERIC)
            computedConcernsTableData() {
                var t = this;
                var tableData = t.concernsTableData;
                var tableDataList = tableData.map(e => {
                    return {
                        id: e.id,
                        concernStatus: e.concernStatus,
                        concernName: e.concernName,
                        concernDescription: e.concernDescription,
                        concernType: e.concernType,
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });
                return (tableDataList);
            },




            // CONCERNS HEADERS

            computedConcernsHeaders() {
              return (this.$filter(this.concernsHeaders, {
                hidden: false, // filter headers based on initial hidden value
              }))
            },
            // LOCATIONS HEADERS
            locationsHeaders() {
                return [
                    { text: 'Name',  value: 'locationName', align: 'left', sortable: false, hidden: false, hide: false },
                    { text: 'Staff', value: 'staff', align: 'center', sortable: false, hidden: false, hide: false },
                    { text: 'Visitors', value: 'visitors', align: 'center', sortable: false, hidden: false, hide: false },
                    { text: 'Contractors', value: 'contractors', align: 'center', sortable: false, hidden: false, hide: false },
                    { text: 'Total', value: 'totalCount', align: 'center', sortable: false, hidden: false, hide: false },
                    { text: 'Actions', value: 'actions', align: 'center', sortable: false, hidden: false, hide: false },
                ]
            },
            // NOTICES HEADERS
            noticesHeaders() {
                return [
                    { text: 'Status', value: 'noticeStatus', align: 'center', sortable: false, hidden: false, hide: false },
                    { text: 'Name',  value: 'noticeName', align: 'left', sortable: false, hidden: false, hide: false },
                    { text: 'Description', value: 'noticeDescription', align: 'center', sortable: false, hidden: false, hide: false },
                    { text: 'Created by', value: 'createdUserData.userName', align: 'center', sortable: false, hidden: false, hide: false },
                    { text: 'Created', value: 'createdDateTime', align: 'center', sortable: false, hidden: false, hide: false },
                    { text: 'Actions', value: 'actions', align: 'center', sortable: false, hidden: false, hide: false },
                ]
            },
            // DOC LINK (GENERIC) - REQUIRED FOR DOCUMENT UPLOAD
            docLink() {
                var t = this;
                return ({ collection: t.collection, documentId: t.form.id })
            },
        },
        // * WATCH
        watch: {
            // Watch for a change in the Open Site Data and then Update the Breadcrumbs
            GET_openSite: {
                handler() {
                    this.updateBreadcrumbs(this.GET_openSite);
                }, deep: true
            },
            GET_confirmBoxResult: {
                handler: async function() {
                    var t = this;
                    if (t.GET_confirmBoxResult.data.collection === 'concerns') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, 'Concern Deleted', deleteResult.data, null);
                            } else {
                                t.MIX_alert(-1, 'Error Deleting Concern', null, deleteResult.error);
                            }
                        }
                    } else if (t.GET_confirmBoxResult.data.collection === 'notices') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, 'Notice Deleted', deleteResult.data, null);
                            } else {
                                t.MIX_alert(-1, 'Error Deleting Notice', null, deleteResult.error);
                            }
                        }
                    } else if (t.GET_confirmBoxResult.data.collection === 'comments') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, 'Comment Deleted', deleteResult.data, null);
                            } else {
                                t.MIX_alert(-1, 'Error Deleting Comment', null, deleteResult.error);
                            }
                        }
                    } else if (t.GET_confirmBoxResult.data.collection === 'sites') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, 'Site Deleted', deleteResult.data, null);
                            } else {
                                t.MIX_alert(-1, 'Error Deleting Site', null, deleteResult.error);
                            }
                        }
                    } else {
                        // Do nothing

                    }
                }, deep: true
            }

        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openSite', 'ACT_openUser': 'ACT_openUser'}),
            // UPDATE BREADCRUMBS
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                if (t.GET_openItem.process === 'New') {
                    breadcrumbs.push ({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}`}) // Set a Secondary Path
                } else {
                    breadcrumbs.push ({ name: `${this.GET_openItem.data[t.collectionItem + 'Name']}`, path: `/${t.collection}/${this.GET_openItem.data.id}`}) // Set a Secondary Path
                }
                this.MIX_breadcrumbs(breadcrumbs);
            },
            // OPEN ITEM
            openItem: async function() {
                var t = this;
                var openItem = await t.GET_openItem; // Get Open Item Data
                switch (openItem.process) {
                    case 'New':
                        t.formMode = 'New'; // Show Form in New Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                    case 'View':
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details
                        t.formMode = 'View'; // Show Form in View Mode
                        t.formReadOnly = true; // Make Form Read Only
                        t.formBackground = 'grey lighten-3'; // Change Background Colour of Form
                        break;
                    case 'Edit':
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details
                        t.formMode = 'Edit'; // Show Form in Edit Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                }
                return;
            },
            // EDIT ITEM
            editItem() {
                var t = this;
                t.formMode = 'Edit';
                t.formReadOnly = false;
                t.formBackground = 'white';
            },
            // CANCEL ITEM
            cancelItem() {
                var t= this;
                t.formMode = 'View';
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                t.removeUploadedDocument();
                t.refreshItemView();
                t.closeRightPanel();
            },
            closeRightPanel() {
                this.updateBreadcrumbs();
                this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
            },
            // SAVE ITEM
            saveItem: async function() {
                var t = this;
                if (t.form.id === undefined) {
                    t.form.id = t.MIX_generateId();  // if new then generate new id
                }                
                if(t.uploadedFile != null){
                    t.form.fileData.fileURL = t.uploadedFile.fileURL;
                    t.form.fileData.fileType = t.uploadedFile.fileType;
                    t.form.fileData.fileName = t.uploadedFile.fileName;
                }

                // console.log('collection: ', t.collection)
                // console.log('form: ', t.form)

                var createDocumentResult = await t.MIX_createDocument(t.collection, t.form); // Create Document Within Firestore based on Form

				// console.log('createDocumentResult: ', createDocumentResult)

				if (createDocumentResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null); // Send Success Alert to Item
                    t.formMode = 'View'; // Change Form Mode
                    t.formReadOnly = true; // Set Form to Read Only
                    t.formBackground = 'grey lighten-3';
                    t.refreshItemView();
                    t.removeUploadedDocument();
                } else {
                    t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null); // Send Error Alert to Item
                }
            },
            // * VALIDATION RULES
			validateForm() {
				let t = this;
                t.rules = {
                    siteName: [
                        v => !!v || 'Notice Name is required',
                        v => (v && v.length < 255) || 'Name must be less than 255 characters',
                    ],
                    siteTelephone: [v => !!v || 'Description Required'],
                    siteAddressLine1: [v => !!v || "Address Required"],
                    siteTown: [v => !!v || "Town Required"],
                    sitePostcode: [v => !!v || "Postcode Required"],
                    siteType: [v => !!v || 'Type Required'],
                }
                //let the DOM update
                t.$nextTick(() => {
                    //manually trigger Vuetify validation
                    if(t.$refs.form.validate()) {
                        this.saveItem();
                    } else {
                        t.MIX_alert(-1, "Please fill out all the fields", null, null);
                    }

                    //if not valid, errors will be automatically displayed
                })
			},

            // UPDATE ITEM STATUS
            updateItemStatus: async function(status) {
                var t = this;
                // console.log('updateResult')
                var updateResult = await t.MIX_updateDocumentFieldsById (t.collection, t.form.id, { [t.collectionItem + 'Status']: status } )
                // console.log('updateResult.code = ' + updateResult.code)
                if (updateResult.code === 1) {
                    t.MIX_alert(1, 'Status Updated', updateResult.data, null);
                    t.refreshItemView();
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateResult.error);
                }
            },
            // REFRESH ITEM VIEW
            refreshItemView: async function() {
                var t = this;
                var itemResult = await t.MIX_readDocumentById(t.collection, t.form.id)
                var payload = {}
                payload.process = 'View';
                payload.popup = false;
                payload.data = itemResult.data;
                t.ACT_openItem(payload);
                t.openItem();
            },
            // DELETE ITEM METHOD
            deleteItem: function (id) {
                var t = this;
                t.MIX_confirmBox(
                    {
                        show: true,
                        collection: t.collection,
                        id: id,
                        title: `Delete ${t.collectionItemTitle}`,
                        description: `Are you sure you want to delete ${t.collectionItemTitle}: <br /><strong>${t.form[t.collectionItem + 'Name']}</strong>?`,
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },
			// REMOVE UPLOADED DOCUMENT
			removeUploadedDocument() {
				this.$store.commit("upload_file_store/setFile", null);
			},
            // UNDELETE ITEM METHOD
            undeleteItem: async function (id) {
                var t = this;
                var undeleteResult = await t.MIX_undeleteDocument(t.collection, id)
                if (undeleteResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Restored`, undeleteResult.data, null);
                } else {
                    t.MIX_alert(-1, `Error Restoring ${t.collectionItemTitle}`, null, undeleteResult.error);
                    // console.log(`undeleteResult.error = ${JSON.stringify(undeleteResult.error, null, 2)}`)
                }
                t.refreshItemView();
            },


            // GET COMMENTS METHOD
            getComments: async function (openItem) {
                var t = this;
                if (JSON.stringify(openItem.data) !== '{}') {
                    t.$firebase.db.collection('comments').where("docLink.documentId", "==", openItem.data.id)
                        .onSnapshot(function(querySnapshot) {
                            t.commentsTableData = [];
                            querySnapshot.forEach(function(doc) {
                                var document = doc.data()
                                document.id = doc.id;
                                if (!document.hasOwnProperty('delete')) {
                                    t.commentsTableData.push(document);
                                } else if (t.showDeletedComments) {
                                     t.commentsTableData.push(document);
                                } else {
                                    // Do not Show Notice
                                }
                            });
                    });
                }
            },
            // GET NOTICES
            getNotices: async function (openSite) {
                var t = this;
                if (JSON.stringify(openSite.data) !== '{}') {
                    t.$firebase.db.collection('notices').where("site.siteId", "==", openSite.data.id)
                        .onSnapshot(function(querySnapshot) {
                            t.noticesTableData = [];
                            querySnapshot.forEach(function(doc) {
                                var document = doc.data()
                                document.id = doc.id;
                                if (!document.hasOwnProperty('delete')) {
                                    t.noticesTableData.push(document);
                                } else if (t.showDeletedNotices) {
                                    t.noticesTableData.push(document);
                                } else {
                                    // Do not Show Notice
                                }
                            });
                    });
                }
            },
            // GET CONCERN METHOD
            getConcerns: async function (openSite) {
                var t = this;
                if (JSON.stringify(openSite) !== '{}') {
                    t.$firebase.db.collection('concerns').where("site.siteId", "==", openSite.data.id)
                        .onSnapshot(function(querySnapshot) {
                            t.concernsTableData = [];
                            querySnapshot.forEach(function(doc) {
                                var document = doc.data()
                                document.id = doc.id;
                                if (!document.hasOwnProperty('delete')) {
                                    t.concernsTableData.push(document);
                                } else if (t.showDeletedConcerns) {
                                    t.concernsTableData.push(document);
                                } else {
                                    // Do not Show Concern
                                }
                            });
                    });
                }
            },
            // GET LOCATIONS METHOD
            getLocations: async function (openSite) {
                var t = this;
                if (JSON.stringify(openSite) !== '{}') {
                    t.$firebase.db.collection('locations').where("site.id", "==", openSite.data.id)
                        .onSnapshot(function(querySnapshot) {
                            t.locationsTableData = [];
                            querySnapshot.forEach(function(doc) {
                                var document = doc.data()
                                document.id = doc.id;
                                if (!document.hasOwnProperty('delete')) {
                                    t.locationsTableData.push(document);
                                } else if (t.showDeletedConcerns) {
                                    t.locationsTableData.push(document);
                                } else {
                                    // Do not Show Concern
                                }
                            });
                    });
                }
            },
            // GET USERS METHOD
            getUsers: async function (openSite) {
                var t = this;
                if (JSON.stringify(openSite) !== '{}') {
                    t.$firebase.db.collection('users').where("lastSite.siteId", "==", openSite.data.id)
                        .onSnapshot(function(querySnapshot) {
                            t.usersTableData = [];
                            querySnapshot.forEach(function(doc) {
                                var document = doc.data()
                                document.id = doc.id;
                                if (!document.hasOwnProperty('delete')) {
                                    t.usersTableData.push(document);
                                } else {
                                    // Do not Show Concern
                                }
                            });
                    });
                }
            },
            // CALCULATE USERS AT LOCATION METHOD
            noOfUsersAtLocation(locationId, userType){
                var count = 0;
                // if a user type is specified
                if(userType !== ''){
                    for(var i = 0; i < this.usersTableData.length; i++){ //usersOnSite
                        if(locationId === this.usersTableData[i].lastLocation.locationId && this.usersTableData[i].swappStatus === 1 && this.usersTableData[i].userType === userType){
                            count++;
                        }
                    }
                }else { // for total count
                    for(var i = 0; i < this.usersTableData.length; i++){
                        if(locationId === this.usersTableData[i].lastLocation.locationId && this.usersTableData[i].swappStatus === 1 ){
                            count++;
                        }
                    }
                }

                return count;
            },
            // GENERATE QR CODE
            openQrCode(id, item, siteTelephone) {
                this.MIX_generateCode(true, id, 300, "H", "qrcode", "canvas", "#ffffff", "#000000", true, item.locationName, item.siteName, siteTelephone);
            },
            // DELETE CONCERN METHOD
            deleteConcern: function (item) {
                this.MIX_confirmBox(
                    {
                        show: true,
                        collection: 'concerns',
                        id: item.id,
                        title: 'Delete Incident',
                        description: `Are you sure you want to delete concern: <strong>${item.concernName}</strong>?`,
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },
            // DELETE NOTICE METHOD
            deleteNotice: function (item) {
                this.MIX_confirmBox(
                    {
                        show: true,
                        collection: 'notices',
                        id: item.id,
                        title: 'Delete Notice',
                        description: `Are you sure you want to delete notice: <strong>${item.noticeName}</strong>?`,
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },
            // DELETE COMMENT METHOD
            deleteComment: function (item) {
                this.MIX_confirmBox(
                    {
                        show: true,
                        collection: 'comments',
                        id: item.id,
                        title: 'Delete Comment',
                        description: `Are you sure you want to delete comment: <strong>${item.comment}</strong>?`,
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },
            // // UNDELETE CONCERN METHOD
            // undeleteConcern: async function (id) {
            //     var t = this;
            //     var undeleteResult = await t.MIX_undeleteDocument('concerns', id)
            //     if (undeleteResult.code === 1) {
            //         t.MIX_alert(1, 'Concern Restored', undeleteResult.data, null);
            //     } else {
            //         t.MIX_alert(-1, 'Error Restoring Concern', null, undeleteResult.error);
            //     }
            // },
            // UNDELETE METHOD
            undeleteNotice: async function (id) {
                var t = this;
                var undeleteResult = await t.MIX_undeleteDocument('notices', id)
                if (undeleteResult.code === 1) {
                    t.MIX_alert(1, 'Notice Restored', undeleteResult.data, null);
                } else {
                    t.MIX_alert(-1, 'Error Restoring Notice', null, undeleteResult.error);
                }
            },
            // CALCULATE ARRAY LENGTH
            calculateArrayLength(array) {
                return array.length;
            },
            // LOOKUP FIELD (GENERIC)
            lookupField: function(lookup, field, value) {
                var t = this;
                var lookupResult = t.$find(t[lookup], { value: value })
                if (lookupResult !== undefined) {
                    return (lookupResult)[field];
                } else {
                    return ('NOTFOUND')
                }
            }

        },
        // * MOUNTED
        async mounted() {
            var t = this;
            // LOOKUP RELATED MOUNTED
            // TODO NOT SURE if I need to lookup values again
            t.siteTypes = await t.GET_lookupValues('SITETYPES');
            t.concernTypes = await t.GET_lookupValues('GENERALCONCERNTYPES');

            // TODO REMOVE STAFF CONCERNS FOR NON STAFF
            var staffConcernTypes = await t.GET_lookupValues('STAFFCONCERNTYPES');
            staffConcernTypes.forEach(function(e) {
                t.concernTypes.push (e)
            })

            t.concernSeverities = await t.GET_lookupValues('CONCERNSEVERITIES');

            // * ITEM RELATED MOUNTED
            var openItem = await t.GET_openItem; // Get Open Project Data
            t.formMode = openItem.process; // Show Form in View Mode
            if (openItem.process === 'New') {
                t.formReadOnly = false;             // Make Form Editable }
                t.formBackground = 'white';
            } else {
                t.form = openItem.data; // Update the Form with the Open Project details
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
            }
            if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Title
            // GET CONCERNS
            t.getUsers(openItem);
            // GET LOCATIONS
            t.getConcerns(openItem);
            // GET LOCATIONS
            t.getLocations(openItem);
            // GET NOTICES
            t.getNotices(openItem);
            // GET COMMENTS
            t.getComments(openItem);

            var getGuide = await t.MIX_readDocumentById('guides', t.collection)
            if (getGuide.code === -1) {
                // Help Guide Does Not Exist
            } else {
                t.guide = getGuide.data;
            }
        }
    };
</script>

<style scoped>
  .disabled >>> .v-input__slot::before {
        border-style: none !important;
    }
    .v-tabs-items{
        width: 100% !important;
        height: 100% !important;
    }
    .v-window-item {
        height: calc(100vh - 170px);
        overflow-y: auto;
    }
    .v-menu__content {
        box-shadow: none !important;
    }
</style>
